import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const SiteContext = createContext(null);

export const STATUS = {
  disponivel: { label: "Disponível", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  reservado: { label: "Reservado", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  vendido: { label: "Vendido", cls: "bg-red-50 text-red-700 border-red-200" },
};

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState({ whatsapp_number: "", instagram_url: "", facebook_url: "" });
  const [properties, setProperties] = useState([]);
  const [loadingProps, setLoadingProps] = useState(true);

  const refreshSettings = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch {}
  }, []);

  const refreshProperties = useCallback(async () => {
    setLoadingProps(true);
    try {
      const { data } = await api.get("/properties");
      setProperties(data);
    } catch {
    } finally {
      setLoadingProps(false);
    }
  }, []);

  useEffect(() => {
    refreshSettings();
    refreshProperties();
  }, [refreshSettings, refreshProperties]);

  const waLink = useCallback(
    (message) => {
      if (!settings.whatsapp_number) return null;
      return `https://wa.me/${settings.whatsapp_number}?text=${encodeURIComponent(message)}`;
    },
    [settings.whatsapp_number]
  );

  const formatPrice = useCallback((value) => {
    if (value == null || value === "") return "Consulte";
    return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 }).format(value);
  }, []);

  return (
    <SiteContext.Provider
      value={{ settings, setSettings, refreshSettings, properties, loadingProps, refreshProperties, waLink, formatPrice }}
    >
      {children}
    </SiteContext.Provider>
  );
}

export const useSite = () => useContext(SiteContext);
